module.exports = __webpack_public_path__ + "static/media/title.94db6661.png";